export const colorTheme = {
  black: "#373F41",
  grayDark: "#737B7D",
  gray: "#C3CBCD",
  divider: "#E2E5E6",
  grayLightest: "#F4F5F4",
  white: "#FFFFFF",
  accentBlue: "#109CF1",
  yellow: "#FFB946",
  red: "#F7685B",
  green: "#2ED47A",
  purple: "#885AF8",
  blue: "#4DABF7",
  newBlue: "#098EDF",
  grayBlue: "#7BA3C2",
  transparentBlue: "rgba(9, 142, 223, 0.1)",
  toggleGray: "#90A0B7",
  chartRed: "#FF6B6B",
  chartYellow: "#FFC078",
  chartGreen: "#38D9A9",
};

export const textTheme = {
  h1: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 56px;
    font-weight: 700;
    line-height: 72px;
    letter-spacing: 0.2px;
  `,
  h2: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 44px;
    font-weight: 700;
    line-height: 56px;
    letter-spacing: 0.2px;
  `,
  h3: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 26px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0.1px;
  `,
  h4: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 22px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: 0.2px;
  `,
  h5: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0.1px;
  `,
  h6: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0.1px;
  `,
  subtitle1: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: 0.1px;
  `,
  subtitle2: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0.2px;
  `,
  body1: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.3px;
  `,
  body2: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.2px;
  `,
  small: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.2px;
  `,
  button: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.3px;
  `,
  caption: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0.3px;
  `,
  price: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 36px;
    font-weight: 300;
    line-height: 60px;
    letter-spacing: 0.2px;
  `,
  tileTrend: `
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-size: 16px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0.44px;
  `,
};

export const textThemeJS = {
  h1: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 56px,
    fontWeight: 700,
    lineHeight: 72px,
    letterWpacing: 0.2px,
  `,
  h2: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 44px,
    fontWeight: 700,
    lineHeight: 56px,
    letterSpacing: 0.2px,
  `,
  h3: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 26px,
    fontWeight: 700,
    lineHeight: 40px,
    letterSpacing: 0.1px,
  `,
  h4: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 22px,
    fontWeight: 600,
    lineHeight: 32px,
    letterSpacing: 0.2px,
  `,
  h5: `
    fontfamily: 'Open Sans', sans-serif,
    fontstyle: normal,
    fontsize: 20px,
    fontweight: 700,
    lineheight: 26px,
    letterspacing: 0.1px,
  `,
  h6: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 18px,
    fontWeight: 600,
    lineHeight: 24px,
    letterSpacing: 0.1px,
  `,
  subtitle1: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 14px,
    fontWeight: 600,
    lineHeight: 22px,
    letterSpacing: 0.1px,
  `,
  subtitle2: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 13px,
    fontWeight: 600,
    lineHeight: 18px,
    letterSpacing: 0.2px,
  `,
  body1: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 14px,
    fontWeight: 400,
    lineHeight: 22px,
    letterSpacing: 0.3px,
  `,
  body2: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 13px,
    fontWeight: 400,
    lineHeight: 20px,
    letterSpacing: 0.2px,
  `,
  small: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 12px,
    fontWeight: 600,
    lineHeight: 16px,
    letterSpacing: 0.2px,
  `,
  button: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 14px,
    fontWeight: 700,
    lineHeight: 18px,
    letterSpacing: 0.3px,
  `,
  caption: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 14px,
    fontWeight: 700,
    lineHeight: 18px,
    letterSpacing: 0.3px,
  `,
  price: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 36px,
    fontWeight: 300,
    lineHeight: 60px,
    letterSpacing: 0.2px,
  `,
  tileTrend: `
    fontFamily: 'Open Sans', sans-serif,
    fontStyle: normal,
    fontSize: 16px,
    fontWeight: 400,
    lineHeight: 17px,
    letterSpacing: 0.44px,
  `,
};
